import type { CurrentUser } from "@/lib/auth";
import { getUserDisplayName } from "@/lib/auth";
import type { TicketCategory, TicketPriority, TicketStatus } from "@/types/supportTicket";

export const TICKET_STATUS_LABELS: Record<TicketStatus, string> = {
  open: "Offen",
  in_progress: "In Bearbeitung",
  waiting: "Wartend",
  resolved: "Erledigt",
  closed: "Geschlossen",
};

export const TICKET_PRIORITY_LABELS: Record<TicketPriority, string> = {
  low: "Niedrig",
  normal: "Normal",
  high: "Hoch",
  urgent: "Dringend",
};

export const TICKET_CATEGORY_LABELS: Record<TicketCategory, string> = {
  technik: "Technik",
  rezeption: "Rezeption",
  buchhaltung: "Buchhaltung",
  plaetze: "Plätze",
  gaeste: "Gästeservice",
  sonstiges: "Sonstiges",
};

export const TICKET_STATUSES = Object.keys(TICKET_STATUS_LABELS) as TicketStatus[];
export const TICKET_PRIORITIES = Object.keys(TICKET_PRIORITY_LABELS) as TicketPriority[];
export const TICKET_CATEGORIES = Object.keys(TICKET_CATEGORY_LABELS) as TicketCategory[];

export function statusLabel(status: string): string {
  return TICKET_STATUS_LABELS[status as TicketStatus] ?? status;
}

export function priorityLabel(priority: string): string {
  return TICKET_PRIORITY_LABELS[priority as TicketPriority] ?? priority;
}

export function categoryLabel(category: string): string {
  return TICKET_CATEGORY_LABELS[category as TicketCategory] ?? category;
}

export function formatTicketNumber(number: number): string {
  return `#${String(number).padStart(4, "0")}`;
}

export function ticketUserLogin(user: CurrentUser | null): string {
  return String(user?.sub || user?.username || "").trim().toLowerCase();
}

export function ticketUserName(user: CurrentUser | null): string {
  return getUserDisplayName(user) || ticketUserLogin(user);
}
